import React, { memo } from "react";
import ShadowCard from "../../../components/common/ShadowCard";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { Field, FieldArray } from "@progress/kendo-react-form";
import { FaStar, FaPlus, FaTimes } from "react-icons/fa";
import IconComponent from "../../../components/common/IconComponent";
import FormTextField from "../../../components/formFields/FormTextField";
import FormNumericTextField from "../../../components/formFields/FormNumericTextField";
// import FormDateField from "../../../components/formFields/FormDateField";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getAllActiveB2BServices } from "../../b2bservice/service/b2bservice.services";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import "../b2bmodule.scss";

const SpecialServicesList = (props: any) => {
    const { value: services = [], onRemove, onPush, activeB2BServices, onFormChange } = props;
    const b2bServiceOptions = (activeB2BServices || []).map((s: any) => ({ label: s.ServiceName, value: s.ID }));
    return (
        <React.Fragment>
            {(services || []).map((item: any, i: number) => {
                if (!item) return null;
                return (
                    <div key={i} className="row g-3 mb-3 align-items-end border-bottom border-light pb-3">
                        <div className="col-12 col-md-3">
                            <Field
                                name={`OtherSpecialServices[${i}].ServiceID`}
                                label="Service Name"
                                placeholder="Select Service"
                                options={b2bServiceOptions}
                                component={FormSelectionField}
                                onChange={(e: any) => {
                                    const val = e.value;
                                    onFormChange(`OtherSpecialServices[${i}].ServiceID`, { value: val });
                                    const opt = b2bServiceOptions.find((o: any) => o.value === val);
                                    if (opt) onFormChange(`OtherSpecialServices[${i}].ServiceName`, { value: opt.label });
                                }}
                            />
                        </div>
                        <div className="col-6 col-md-2">
                            <Field
                                name={`OtherSpecialServices[${i}].TotalPrice`}
                                label="Price (INR)"
                                component={FormNumericTextField}
                            />
                        </div>
                        <div className="col-6 col-md-2">
                            <Field
                                name={`OtherSpecialServices[${i}].DayNo`}
                                label="Day No."
                                placeholder="Select Day"
                                options={props.dayOptions}
                                component={FormSelectionField}
                            />
                        </div>
                        <div className="col-10 col-md-4">
                            <Field
                                name={`OtherSpecialServices[${i}].Comment`}
                                label="Internal Notes"
                                placeholder="Add special requests..."
                                component={FormTextField}
                            />
                        </div>
                        <div className="col-1 col-md-1 pb-2 d-flex justify-content-center">
                            <div className="b2b-remove-icon" onClick={() => onRemove({ index: i })} title="Remove">
                                <IconComponent icon={FaTimes} style={{ fontSize: "11px" }} />
                            </div>
                        </div>
                    </div>
                );
            })}
            <div className="mt-3">
                <Button
                    type="button"
                    fillMode="outline"
                    themeColor="primary"
                    size="small"
                    className="fw-bold"
                    onClick={() => onPush({ value: { ServiceID: 0, TotalPrice: 0, Day: "", DayNo: 0, Comment: "" } })}
                >
                    <IconComponent icon={FaPlus} className="me-1" /> Add Special Service
                </Button>
            </div>
        </React.Fragment>
    );
};

const OtherSpecialServicesSection: React.FC<{ dayOptions: any[], onFormChange?: any }> = ({ dayOptions, onFormChange }) => {
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(getAllActiveB2BServices());
    }, [dispatch]);

    const activeB2BServices = useAppSelector((state: any) => state.b2bservice.B2BServiceList || []);

    return (
        <ShadowCard className="b2b-quotation-module b2b-card mb-4 p-0">
            <div className="p-4 d-flex gap-3 align-items-start border-bottom border-light">
                <div className="hotel-icon-wrap shadow-sm">
                    <IconComponent icon={FaStar} />
                </div>
                <div className="flex-grow-1">
                    <div className="d-flex align-items-center gap-2">
                        <Typography.h5 className="section-title mb-0">Other Special Services</Typography.h5>
                    </div>
                    <Typography.p className="section-subtitle mb-0 mt-1" style={{ fontSize: "13px" }}>
                        Add miscellaneous services like off-road dinners, trekking, or custom celebrations.
                    </Typography.p>
                </div>
            </div>

            <div className="p-4">

                <FieldArray
                    name="OtherSpecialServices"
                    component={SpecialServicesList}
                    activeB2BServices={activeB2BServices}
                    dayOptions={dayOptions}
                    onFormChange={onFormChange}
                />
            </div>
        </ShadowCard>
    );
};

export default memo(OtherSpecialServicesSection);
